module.exports = __webpack_public_path__ + "static/fonts/notokr-bold.84cf469.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/font/notosanskr/notokr-bold.woff
// module id = FGrs
// module chunks = 0